var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.6064453,5.3935547c-1.0556641-1.0556641-2.2207031-1.9326172-3.4628906-2.6054688l-0.953125,1.7578125 c1.0732422,0.5820312,2.0830078,1.3427734,3.0019531,2.2617188C27.6474609,9.2626953,29,12.5273438,29,16 s-1.3525391,6.7373047-3.8076172,9.1923828S19.4726562,29,16,29s-6.7373047-1.3525391-9.1923828-3.8076172S3,19.4726562,3,16 s1.3525391-6.7373047,3.8076172-9.1923828c0.9189453-0.9189453,1.9287109-1.6796875,3.0019531-2.2617188l-0.953125-1.7578125 C7.6142578,3.4609375,6.4492188,4.3378906,5.3935547,5.3935547C2.5605469,8.2265625,1,11.9931641,1,16 s1.5605469,7.7734375,4.3935547,10.6064453S11.9931641,31,16,31s7.7734375-1.5605469,10.6064453-4.3935547S31,20.0068359,31,16 S29.4394531,8.2265625,26.6064453,5.3935547z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 0,
    width: 2,
    height: 16
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnSmall);
export default __webpack_public_path__ + "static/media/on--small.b880c7134947830c06997d05b6ed8d0b.svg";
export { ForwardRef as ReactComponent };